import React, { FC, memo } from 'react'
import { Text } from '@ucheba/ui/components/Text/desktop'
import { Spacing } from '@ucheba/ui/components/Spacing/desktop'
import { useCreateContent } from '@ucheba/utils/hooks/useCreateContent'
import { IEventsId } from '@ucheba/store/events/id/types'
import BlockWithText from '../../../../BlockWithText/desktop'
import BlockWithList from '../../../../BlockWithList/desktop/BlockWithList'
import BlockWithCards from '../../../../BlockWithCards/desktop'
import BlockWithListImages from '../../../../BlockWithListImages/desktop'
import BlockWithImageBoxes from '../../../../BlockWithImageBoxes/desktop'
import BlockWithCardsList from '../../../../BlockWithCardsList/desktop'
import BlockWithImage from '../../../../BlockWithImage/desktop'
import BlockWithTimetable from '../../../../BlockWithTimetable/desktop'

const EventsContent: FC<Pick<IEventsId, 'content'>> = (props) => {
  const { content } = props
  const components = {
    Text,
    BlockWithText,
    BlockWithList,
    BlockWithCards,
    BlockWithListImages,
    BlockWithImageBoxes,
    BlockWithCardsList,
    BlockWithImage,
    BlockWithTimetable,
  }

  const contentElements = useCreateContent({
    data: content,
    components,
  })

  return (
    <>
      {contentElements}

      <Spacing spacing='xlarge' />
    </>
  )
}

export default memo(EventsContent)
